const collectionItem = class extends HTMLElement {
  constructor () {
    super()

    this.swatches = this.querySelectorAll('[data-collection-item-swatch]')
    this.quickShop = this.querySelector('[data-collection-item-quickshop]')
    this.image = this.querySelector('[data-collection-item-image]')
    this.linkEls = this.querySelectorAll('[data-collection-item-link]')
    this.priceEl = this.querySelector('[price]')
  }

  connectedCallback () {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        this.updateColor(swatch)
        this.updateWishlist(swatch.dataset.variantId)
      })
    });
  }

  updateColor(swatch) {
    this.swatches.forEach(el => {
      el.classList.remove('active')
    })
    swatch.classList.add('active')

    if (this.image) {
      this.image.src = swatch.dataset.imageUrl
      this.image.setAttribute('data-srcset', swatch.dataset.imageSrcset)
      this.image.setAttribute('srcset', swatch.dataset.imageSrcset)
    }

    this.linkEls.forEach(linkEl => {
      linkEl.href = swatch.dataset.url
    })

    if (this.quickShop) console.log('update this')
  }

  updateWishlist (id) {
    const wishlistButton = this.querySelector('[data-collection-item-wishlist]')
    if (!wishlistButton) { return }

    wishlistButton.setAttribute('data-variant-id', id)
    document.dispatchEvent(new CustomEvent('swym:variant-changed'));
  }
}

if (typeof window.customElements.get('collection-item') === 'undefined') {
  window.customElements.define('collection-item', collectionItem)
}